export default __webpack_public_path__ + "static/media/syncing.87c43508.svg";